import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgxDropzonePreviewComponent } from 'ngx-dropzone';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-custom-preview',
    templateUrl: './custom-preview.component.html',
    styleUrls: ['./custom-preview.component.scss'],
    providers: [
        {
            provide: NgxDropzonePreviewComponent,
            useExisting: CustomPreviewComponent,
        },
    ],
})
export class CustomPreviewComponent
    extends NgxDropzonePreviewComponent
    implements OnInit {
    @Input() file: File;
    @Input() private: boolean;
    @Output() onChangePrivacity = new EventEmitter<any>();

    constructor(sanitizer: DomSanitizer) {
        super(sanitizer);
    }

    ngOnInit(): void {
        if (!this.file) {
            console.error(
                'No file to read. Please provide a file using the [file] Input property.'
            );
            return;
        }
    }

    // togglePrivacity(): void {
    //     this.private = !this.private;
    //     this.onChangePrivacity.emit(this.private);
    // }
}
